<template>
  <div>
    <data-table
    table-ref="rentalduetable"

    :url="'/report/property/due/' + rowData.id"
    :fields="fields"

    title="Tenancy Due"
    icon="fa fa-asterisk"

    hide-org-badge
    :show-search="false"

     />

  </div>

</template>

<script>

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

export default {
  mixins: [DateMixins, NumberMixins],

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },


  data () {
    return {
      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          name: 'site.siteId',
          title: 'Site Id',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          visible: !this.siteId
        },
        {
          name: 'status',
          title: 'Status',
          titleClass: 'hidden-md-and-down text-primary',
          dataClass: 'hidden-md-and-down text-primary'
        },
        {
          name: 'landowner',
          title: 'Landlord',
          visible: this.isTowerCo()
        },
        {
          name: 'years',
          title: 'Years',
          callback: this.formatInteger,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'term',
          title: 'Term',
          callback: this.formatInteger,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'nextPaymentDate',
          title: 'Date Due',
          callback: this.formatDate,
          titleClass: 'text-danger',
          dataClass: 'text-danger text-right'
        },
        {
          name: 'nextPayment',
          title: 'Due',
          callback: this.formatMoney,
          titleClass: 'text-danger',
          dataClass: 'text-danger text-right'
        },
        {
          name: 'paid',
          title: 'Paid',
          callback: this.formatMoney,
          titleClass: 'hidden-sm-and-down text-success',
          dataClass: 'hidden-sm-and-down text-success text-right'
        },
        {
          name: 'outstanding',
          title: 'O/S',
          callback: this.formatMoney,
          titleClass: 'hidden-xs-only text-warning',
          dataClass: 'hidden-xs-only text-warning text-right'
        },
        {
          name: 'expiry',
          title: 'Expiry',
          titleClass: 'text-danger',
          dataClass: 'text-danger',
          callback: this.formatDate
        },
      ]
    }
  }

}

</script>



// WEBPACK FOOTER //
// Tenancy.vue?867ca6fc